<script>
import {Doughnut} from 'vue-chartjs'

export default {
    name: 'doughnut',
    extends: Doughnut,
    props: ['occupancyData'],
    mounted() {
        this.renderChart(
            {
                datasets: this.occupancyData.map(od => ({
                    data: od.items.map(i => i.chartValueOverride ? i.chartValueOverride : i.value),
                    backgroundColor: od.items.map(i => i.chartBackgroundOverride ? i.chartBackgroundOverride : i.background),
                    weight: od.weight,
                    borderWidth: 0
                }))
            },

            {
                responsive: true,
                maintainAspectRatio: false,
                legend: undefined,
                cutoutPercentage: 75,
            }
        );
    }
}
</script>



// WEBPACK FOOTER //
// src/templates/part/chart/doughnut.vue